import React from 'react';
// import { useDemo } from '../../state/DemoContext'; // Unused import
import { formatCurrency, formatDate } from '../../utils/helpers';
import './lenderdashboard.css';

const LenderDashboard = () => {
  // const { state } = useDemo(); // Unused

  // Mock lender data
  const lenderData = {
    portfolio: {
      totalInvested: 8500000,
      activeInvestments: 12,
      totalReturns: 425000,
      averageReturn: 5.0
    },
    availableOpportunities: [
      {
        id: 'opp-1',
        assetType: 'Commercial Real Estate',
        amount: 2500000,
        ltv: 0.65,
        interestRate: 6.5,
        term: '24 months',
        location: 'San Francisco, CA',
        borrower: 'TechCorp Properties',
        riskScore: 'Low'
      },
      {
        id: 'opp-2',
        assetType: 'Equipment Finance',
        amount: 1200000,
        ltv: 0.70,
        interestRate: 7.2,
        term: '36 months',
        location: 'Austin, TX',
        borrower: 'Manufacturing Inc',
        riskScore: 'Medium'
      },
      {
        id: 'opp-3',
        assetType: 'Inventory Finance',
        amount: 800000,
        ltv: 0.60,
        interestRate: 8.1,
        term: '18 months',
        location: 'Chicago, IL',
        borrower: 'Retail Solutions',
        riskScore: 'Medium'
      }
    ],
    recentInvestments: [
      {
        id: 'inv-1',
        assetType: 'Commercial Real Estate',
        amount: 3000000,
        interestRate: 6.2,
        borrower: 'Real Estate Holdings',
        investmentDate: '2024-11-15',
        status: 'Active',
        currentValue: 3100000
      },
      {
        id: 'inv-2',
        assetType: 'Equipment Finance',
        amount: 1500000,
        interestRate: 7.5,
        borrower: 'Industrial Corp',
        investmentDate: '2024-10-20',
        status: 'Active',
        currentValue: 1520000
      }
    ],
    marketInsights: {
      totalMarketValue: 125000000,
      averageLtv: 0.68,
      averageInterestRate: 6.8,
      marketTrend: 'Stable'
    }
  };

  const handleInvest = (opportunityId) => {
    // Mock investment processing
    console.log(`Processing investment for opportunity ${opportunityId}`);
  };

  const getRiskColor = (risk) => {
    switch (risk) {
      case 'Low': return '#22C55E';
      case 'Medium': return '#F59E0B';
      case 'High': return '#EF4444';
      default: return '#6B7280';
    }
  };

  return (
    <div className="jo-xyz-demo-lender-dashboard">
      <div className="jo-xyz-demo-lender-dashboard__header">
        <h1>Lender Dashboard</h1>
        <p>Manage your investment portfolio, discover opportunities, and track performance</p>
      </div>

      {/* Portfolio Metrics */}
      <div className="jo-xyz-demo-lender-dashboard__metrics">
        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">💰</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{formatCurrency(lenderData.portfolio.totalInvested)}</div>
            <div className="jo-xyz-demo-metric-card__label">Total Invested</div>
          </div>
        </div>
        
        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">📈</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{formatCurrency(lenderData.portfolio.totalReturns)}</div>
            <div className="jo-xyz-demo-metric-card__label">Total Returns</div>
          </div>
        </div>
        
        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">🎯</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{lenderData.portfolio.averageReturn}%</div>
            <div className="jo-xyz-demo-metric-card__label">Average Return</div>
          </div>
        </div>
        
        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">📊</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{lenderData.portfolio.activeInvestments}</div>
            <div className="jo-xyz-demo-metric-card__label">Active Investments</div>
          </div>
        </div>
      </div>

      {/* Available Opportunities */}
      <div className="jo-xyz-demo-lender-dashboard__section">
        <h2>Available Opportunities</h2>
        <div className="jo-xyz-demo-opportunities-grid">
          {lenderData.availableOpportunities.map((opportunity) => (
            <div key={opportunity.id} className="jo-xyz-demo-opportunity-card">
              <div className="jo-xyz-demo-opportunity-card__header">
                <div className="jo-xyz-demo-opportunity-card__amount">{formatCurrency(opportunity.amount)}</div>
                <div 
                  className="jo-xyz-demo-opportunity-card__risk"
                  style={{ color: getRiskColor(opportunity.riskScore) }}
                >
                  {opportunity.riskScore} Risk
                </div>
              </div>
              
              <div className="jo-xyz-demo-opportunity-card__details">
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">Asset Type:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{opportunity.assetType}</span>
                </div>
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">LTV:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{(opportunity.ltv * 100).toFixed(0)}%</span>
                </div>
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">Interest Rate:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{opportunity.interestRate}%</span>
                </div>
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">Term:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{opportunity.term}</span>
                </div>
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">Location:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{opportunity.location}</span>
                </div>
                <div className="jo-xyz-demo-opportunity-detail">
                  <span className="jo-xyz-demo-opportunity-detail__label">Borrower:</span>
                  <span className="jo-xyz-demo-opportunity-detail__value">{opportunity.borrower}</span>
                </div>
              </div>
              
              <div className="jo-xyz-demo-opportunity-card__actions">
                <button className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary">View Details</button>
                <button 
                  className="jo-xyz-demo-btn jo-xyz-demo-btn--primary"
                  onClick={() => handleInvest(opportunity.id)}
                >
                  Invest Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Recent Investments */}
      <div className="jo-xyz-demo-lender-dashboard__section">
        <h2>Recent Investments</h2>
        <div className="jo-xyz-demo-investments-grid">
          {lenderData.recentInvestments.map((investment) => (
            <div key={investment.id} className="jo-xyz-demo-investment-card">
              <div className="jo-xyz-demo-investment-card__header">
                <div className="jo-xyz-demo-investment-card__amount">{formatCurrency(investment.amount)}</div>
                <div className="jo-xyz-demo-investment-card__status">{investment.status}</div>
              </div>
              
              <div className="jo-xyz-demo-investment-card__details">
                <div className="jo-xyz-demo-investment-detail">
                  <span className="jo-xyz-demo-investment-detail__label">Asset Type:</span>
                  <span className="jo-xyz-demo-investment-detail__value">{investment.assetType}</span>
                </div>
                <div className="jo-xyz-demo-investment-detail">
                  <span className="jo-xyz-demo-investment-detail__label">Interest Rate:</span>
                  <span className="jo-xyz-demo-investment-detail__value">{investment.interestRate}%</span>
                </div>
                <div className="jo-xyz-demo-investment-detail">
                  <span className="jo-xyz-demo-investment-detail__label">Borrower:</span>
                  <span className="jo-xyz-demo-investment-detail__value">{investment.borrower}</span>
                </div>
                <div className="jo-xyz-demo-investment-detail">
                  <span className="jo-xyz-demo-investment-detail__label">Investment Date:</span>
                  <span className="jo-xyz-demo-investment-detail__value">{formatDate(investment.investmentDate)}</span>
                </div>
                <div className="jo-xyz-demo-investment-detail">
                  <span className="jo-xyz-demo-investment-detail__label">Current Value:</span>
                  <span className="jo-xyz-demo-investment-detail__value">{formatCurrency(investment.currentValue)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Market Insights */}
      <div className="jo-xyz-demo-lender-dashboard__section">
        <h2>Market Insights</h2>
        <div className="jo-xyz-demo-market-insights">
          <div className="jo-xyz-demo-market-insight">
            <div className="jo-xyz-demo-market-insight__value">{formatCurrency(lenderData.marketInsights.totalMarketValue)}</div>
            <div className="jo-xyz-demo-market-insight__label">Total Market Value</div>
          </div>
          <div className="jo-xyz-demo-market-insight">
            <div className="jo-xyz-demo-market-insight__value">{(lenderData.marketInsights.averageLtv * 100).toFixed(0)}%</div>
            <div className="jo-xyz-demo-market-insight__label">Average LTV</div>
          </div>
          <div className="jo-xyz-demo-market-insight">
            <div className="jo-xyz-demo-market-insight__value">{lenderData.marketInsights.averageInterestRate}%</div>
            <div className="jo-xyz-demo-market-insight__label">Average Interest Rate</div>
          </div>
          <div className="jo-xyz-demo-market-insight">
            <div className="jo-xyz-demo-market-insight__value">{lenderData.marketInsights.marketTrend}</div>
            <div className="jo-xyz-demo-market-insight__label">Market Trend</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LenderDashboard;
